export default "__VITE_ASSET__B6px4u43__"